import { useEffect, useMemo, useState } from 'react';
import Fuse from 'fuse.js';
import { UseSearch } from './useSearch.types';

export const useSearch: UseSearch = (
  data,
  searchOptions,
) => {
  const [filteredData, setFilteredData] = useState(data || []);

  const fuse = useMemo(
    () => new Fuse(data, searchOptions),
    [data, searchOptions],
  );

  const onSearchChange = (searchString: string) => {
    if (!searchString) {
      setFilteredData(data || []);
    } else {
      const searchResult = fuse.search(searchString);
      setFilteredData(searchResult as []);
    }
  };

  useEffect(() => {
    setFilteredData(data || []);
  }, [data]);

  return {
    filteredData,
    onSearchChange,
  };
}
